import { NextSteps } from '@percihealth/react';

export const AvivaReferralNextSteps = () => (
  <NextSteps
    intro="Once you have filled in this online referral form or emailed us with it, we will send you a confirmation email for your records. We will then:"
    steps={[
      <>
        <b>Email your patient</b> to let them know that we have received your
        referral.
      </>,
      <>
        Include a{' '}
        <b>link to book with their dedicated cancer nurse specialist</b>.
      </>,
      <>
        <b>Keep you updated</b> on their progress after we have met with them.
      </>,
    ]}
  />
);
